import request from '../request';
import querystring from 'querystring';

export default async function getRequest(baseUrl, params = '') {
	if (params) params = `?${querystring.stringify(params)}`;

	let url = `${baseUrl}${params}`;
	let response = await request({
		method: 'get',
		url
	});
	return response;
}
